export enum RateCode {
  Standard = 'Standard',
  Express = 'Express',
}
